import styled from 'vue3-styled-components';

export const UploadModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    animation: fadeIn 0.3s ease-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export const ModalOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ModalContent = styled.div`
    background: white;
    border-radius: 20px;
    width: 90%;
    max-width: 600px;
    max-height: 80vh;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
        from {
            transform: translateY(50px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 40px 20px;
    border-bottom: 1px solid #f1f5f9;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a5f72 100%);
    color: white;
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: white;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
    padding: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.2s ease;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
    }
`;

export const ModalBody = styled.div`
    padding: 40px;
`;

export const UploadArea = styled.div`
    border: 2px dashed #cbd5e1;
    border-radius: 16px;
    padding: 60px 40px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #fafbfc;
    
    &:hover, &.drag-over {
        border-color: #0f4c5c;
        background: #f0fdf4;
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(15, 76, 92, 0.1);
    }

    &.drag-over {
        border-color: #22c55e;
        background: #f0fdf4;
    }
`;

export const UploadIcon = styled.div`
    font-size: 64px;
    margin-bottom: 20px;
    opacity: 0.6;
    transition: all 0.3s ease;
`;

export const UploadText = styled.p`
    font-size: 18px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
`;

export const UploadSubText = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
`;

export const SelectedFilesList = styled.div`
    margin-top: 30px;
    max-height: 200px;
    overflow-y: auto;

    /* 커스텀 스크롤바 */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 3px;
        
        &:hover {
            background: #94a3b8;
        }
    }
`;

export const FileItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    margin-bottom: 12px;
    background: #fafbfc;
    transition: all 0.2s ease;

    &:hover {
        background: #f3f4f6;
        border-color: #d1d5db;
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

export const FileInfo = styled.div`
    flex: 1;
    text-align: left;
`;

export const FileName = styled.div`
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
    margin-bottom: 4px;
`;

export const FileSize = styled.div`
    color: #6b7280;
    font-size: 12px;
`;

export const RemoveFileButton = styled.button`
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    color: white;
    border: none;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
    
    &:hover {
        background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
        transform: scale(1.1);
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
    }
`;

export const UploadProgress = styled.div`
    margin-top: 30px;
    padding: 20px;
    background: #f8fafc;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
`;

export const ProgressBar = styled.div`
    width: 100%;
    height: 12px;
    background-color: #e5e7eb;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 12px;
`;

export const ProgressFill = styled.div`
    height: 100%;
    background: linear-gradient(135deg, #0f4c5c 0%, #22c55e 100%);
    transition: width 0.3s ease;
    border-radius: 6px;
`;

export const ProgressText = styled.p`
    text-align: center;
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 30px 40px;
    border-top: 1px solid #f1f5f9;
    background: #fafbfc;
`;

export const CancelButton = styled.button`
    padding: 14px 32px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    background: white;
    color: #6b7280;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        border-color: #d1d5db;
        background: #f9fafb;
        color: #374151;
    }
`;

export const UploadButton = styled.button`
    padding: 14px 32px;
    border: none;
    border-radius: 12px;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a5f72 100%);
    color: white;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(15, 76, 92, 0.3);
    
    &:hover:not(:disabled) {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #1a5f72 0%, #0f4c5c 100%);
        box-shadow: 0 8px 25px rgba(15, 76, 92, 0.4);
    }
    
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: 0 4px 12px rgba(15, 76, 92, 0.2);
    }
`;